import { useTranslation } from "react-i18next";
import { Mail, MapPin, Clock, ShieldCheck, MessageCircle } from "lucide-react";
import { CONTACT } from "@/lib/content";

export const ContactInfoSidebar = () => {
  const { t } = useTranslation();
  const nextItems = t("contact.next.items", { returnObjects: true });
  const safeItems = Array.isArray(nextItems) ? nextItems : [];

  return (
    <aside className="space-y-5">
      <div className="rounded-2xl border border-slate-200 bg-white p-6" data-testid="contact-sla-card">
        <div className="flex items-center gap-2 text-emerald-700">
          <ShieldCheck className="h-5 w-5" />
          <span className="text-sm font-semibold">{t("contact.sla.kicker")}</span>
        </div>
        <h3 className="mt-3 text-lg font-extrabold text-slate-900">{t("contact.sla.title")}</h3>
        <p className="mt-2 text-sm text-slate-600">{t("contact.sla.body")}</p>
        <ul className="mt-4 space-y-2 text-sm text-slate-700">
          <li className="flex items-start gap-2">
            <Clock className="mt-0.5 h-4 w-4 text-slate-500" /> {CONTACT.hours}
          </li>
          <li className="flex items-start gap-2">
            <Mail className="mt-0.5 h-4 w-4 text-slate-500" />
            <a className="hover:text-slate-900" href={`mailto:${CONTACT.emailHelp}`}>{CONTACT.emailHelp}</a>
          </li>
          <li className="flex items-start gap-2">
            <Mail className="mt-0.5 h-4 w-4 text-slate-500" />
            <a className="hover:text-slate-900" href={`mailto:${CONTACT.emailCollab}`}>{CONTACT.emailCollab}</a>
          </li>
          <li className="flex items-start gap-2">
            <MessageCircle className="mt-0.5 h-4 w-4 text-slate-500" />
            <a
              className="hover:text-slate-900"
              href={`https://wa.me/${CONTACT.whatsappE164}`}
              target="_blank"
              rel="noreferrer"
            >
              WhatsApp: {CONTACT.whatsapp}
            </a>
          </li>
          <li className="flex items-start gap-2">
            <MapPin className="mt-0.5 h-4 w-4 text-slate-500" />
            <span>{CONTACT.addressLine1}, {CONTACT.addressLine2}, {CONTACT.addressLine3}</span>
          </li>
        </ul>
      </div>

      <div className="rounded-2xl border border-blue-200 bg-blue-50 p-6">
        <h3 className="text-base font-extrabold text-slate-900">{t("contact.next.title")}</h3>
        <ol className="mt-3 space-y-2 text-sm text-slate-700">
          {safeItems.map((item) => (
            <li key={item} className="flex items-start gap-2">
              <span className="mt-1 inline-flex h-1.5 w-1.5 rounded-full bg-blue-600" /> {item}
            </li>
          ))}
        </ol>
      </div>
    </aside>
  );
};
